export default "__VITE_ASSET___eUV$EDU__"